import React, { PropTypes } from 'react'
import { Field, change } from 'redux-form'

import { Select, Label, validators } from 'form'

import css from './style.scss'

const checkboxId = 'selectschoolorcollege-input'

export const requiredUnlessNotListed = (value, allValues) => {
  if (allValues.school_or_college_not_listed) return undefined
  return validators.required('School or College is required')(value)
}

/**
 * Renders the school/college Select alongside a checkbox for "not listed".
 * Used as the `component` for a redux-form Field on `school_or_college_not_listed`;
 * it nests a second Field for `school_or_college_id` so the two stay in the
 * same form and can be kept mutually exclusive.
 */
const SelectSchoolOrCollege = ({ input, meta: { dispatch, form }, options, disabled }) => {
  const notListed = !!input.value

  const handleCheck = (e) => {
    const checked = e.target.checked
    input.onChange(checked)
    if (checked) {
      dispatch(change(form, 'school_or_college_id', null))
    }
  }

  const checkbox = (
    <div className={css.checkboxContainer}>
      <input
        className={css.checkbox}
        type='checkbox'
        id={checkboxId}
        disabled={disabled}
        checked={notListed}
        onChange={handleCheck}
      />
      <Label className={css.label} htmlFor={checkboxId}>
        I do not see my school or college
      </Label>
    </div>
  )

  return (
    <div className={css.container}>
      <Field
        name='school_or_college_id'
        component={Select}
        validate={requiredUnlessNotListed}
        options={options.map(option => ({ name: option.name, value: option.id }))}
        disabled={disabled || notListed}
        afterControl={checkbox}
      />
    </div>
  )
}

SelectSchoolOrCollege.propTypes = {
  input: PropTypes.object.isRequired,
  meta: PropTypes.object.isRequired,
  options: PropTypes.arrayOf(PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
    name: PropTypes.string
  })).isRequired,
  disabled: PropTypes.bool
}

SelectSchoolOrCollege.defaultProps = {
  disabled: false
}

export default SelectSchoolOrCollege
